// Mobile-first breakpoints for PWA
// This app is designed exclusively for mobile phones (<428px)
const breakpoints = {
  values: {
    xs: 0,       // Extra small (default mobile)
    sm: 375,     // iPhone SE and small phones
    md: 600,     // Large phones / small tablets
    lg: 900,     // Tablets
    xl: 1200     // Desktop (not primary target)
  }
};

export default breakpoints;
